import React, { Fragment, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { Button } from "components"
import TnSnappboxLogoutButton from "./TnSnappboxLogoutButton"
import { getSnapboxWallet } from "services"
import TnSnapboxOtpModal from "./TnSnapboxOtpModal"
import { thousandSeparator } from "utils"
import TnSnappboxDropdown from "./TnSnappboxDropdown"
import classes from "./index.module.scss"

// https://app.snapp-box.com/auth

const TnSnapbox = () => {
  const [t] = useTranslation()

  const userBranches =
    useSelector(state => state.userAccountInfo.userBranches)

  const [selectedBranch, setSelectedBranch] = useState(null)
  const [snapboxBalance, setSnapboxBalance] = useState(null)
  const [openOtpModal, setOpenOtpModal] = useState(false)
  const [needOtp, setNeedOtp] = useState(false)

  const unmount = useRef(false)

  const getSnappboxBalance = async () => {
    if (selectedBranch === null) return

    try {
      const { currentBalance } =
        await getSnapboxWallet(selectedBranch._id)

      if (unmount.current) return

      setSnapboxBalance(currentBalance / 10 | 0)

      setNeedOtp(false)
    } catch (err) {
      console.log(err)

      if (unmount.current) return

      setNeedOtp(true)
    }
  }

  const getInitialBranch = () => {
    if (selectedBranch !== null) return

    if (!userBranches?.[0]) return

    const selectedBranchId =
      localStorage.getItem("ssbid")

    const initialBranch =
      userBranches.find(ub => ub._id === selectedBranchId) ||
      userBranches[0]

    setSelectedBranch(initialBranch)
  }

  useEffect(() => {
    getInitialBranch()
  }, [userBranches])

  useEffect(() => {
    getSnappboxBalance()
  }, [selectedBranch])

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <Fragment>
      {needOtp
        ?
        <div className={classes["top"]}>
          <Button
            className={classes["button"]}
            onClick={() => setOpenOtpModal(true)}
          >
            {t("ورود_به_اسنپ_باکس")}
          </Button>

          <TnSnappboxDropdown
            selectedBranch={selectedBranch}
            setSelectedBranch={setSelectedBranch}
          />
        </div>
        :
        snapboxBalance !== null &&
        <div className={classes["row"]}>
          <div className={classes["snapbox-balance"]}>
            <a
              className={classes["link"]}
              target="_blank"
              href="https://app.snapp-box.com/auth"
              rel="noreferrer"
            >
              {t("اسنپ_باکس")}:
            </a>
            <TnSnappboxDropdown
              selectedBranch={selectedBranch}
              setSelectedBranch={setSelectedBranch}
            />
            <b>{thousandSeparator(snapboxBalance)}</b>
          </div>

          <TnSnappboxLogoutButton
            setNeedOtp={setNeedOtp}
            selectedBranch={selectedBranch}
            setSelectedBranch={setSelectedBranch}
          />
        </div>
      }

      <TnSnapboxOtpModal
        setSnapboxBalance={setSnapboxBalance}
        setNeedOtp={setNeedOtp}
        openOtpModal={openOtpModal}
        setOpenOtpModal={setOpenOtpModal}
        selectedBranch={selectedBranch}
      />
    </Fragment>
  )
}

export default TnSnapbox